import React, { memo } from 'react';
import { string, object } from 'prop-types';
import classNames from 'classnames/bind';

import { withLabels } from 'containers/withLabels';
import Button from 'components/Button';

import styles from './BtnPrint.module.scss';
import IconPrint from 'media/icons/print.icon.svg';

const cx = classNames.bind(styles);

const printPage = () => {
  window.print();
};

const BtnPrint = ({ className, labels }) => (
  <Button
    className={cx(className, 'btn')}
    type={'print'}
    onClick={printPage}
  >
    <span className={cx('btn-text')}>{labels.printButtonLabel}</span>
    <span className={cx('btn-icon', 'icon-print')}>
      <IconPrint />
    </span>
  </Button>
);

BtnPrint.propTypes = {
  className: string,
  labels: object.isRequired,
};

BtnPrint.defaultProps = {
  className: null,
};

export default memo(withLabels(BtnPrint));



// WEBPACK FOOTER //
// ./src/components/BtnPrint/BtnPrint.js